import { OnInit } from '@angular/core';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { LocaleService } from '@app/core/i18n';

@Component({
  selector: 'vc-mmao-form',
  templateUrl: './mmao-form.component.html',
  styleUrls: ['./mmao-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MmaoFormComponent implements OnInit {
  @Input()
  min: number;
  @Input()
  max: number;
  @Input()
  role: string;
  @Input()
  action: string;
  @Input()
  currency: string;
  @Input()
  isLastOffer = false;
  @Input()
  hasError = false;
  @Output()
  public submitOffer = new EventEmitter<number>();

  @Output()
  cancelOffer = new EventEmitter<boolean>();

  // Form
  public offerFormGroup: FormGroup;
  public offerFormControl: FormControl;
  public offerFormControlFocused = false;
  public formSubmitted = false;

  constructor(private localeService: LocaleService) {}

  ngOnInit(): void {
    this.buildForm();
  }

  submit() {
    if (this.offerFormGroup.valid) {
      this.submitOffer.emit(this.offer.value);
      this.formSubmitted = true;
    }
  }

  setOfferFormControlFocus() {
    this.offerFormControl.markAsTouched();
    this.offerFormControlFocused = true;
  }

  cancel() {
    this.cancelOffer.emit(true);
  }

  get offer() {
    return this.offerFormGroup.get('offerFormControl');
  }

  get currencySymbol(): string {
    return this.localeService.getCurrencySymbol(this.currency);
  }

  private buildForm(): void {
    this.offerFormControl = new FormControl(null, [
      Validators.required,
      Validators.max(this.max),
      Validators.min(this.min)
    ]);

    this.offerFormGroup = new FormGroup({
      offerFormControl: this.offerFormControl
    });
  }
}
